import { cls } from "@wss/cls";
import React from "react";
import { Price, UnitOfMeasure } from "~/features/pricing/ui";

interface StandardPriceProps {
  price: number;
  unitOfMeasure?: string;
  extraText?: string;
}

const StandardPrice = ({
  price,
  unitOfMeasure,
  extraText,
}: StandardPriceProps) => (
  <div className={cls("align-baseline", !extraText && "mt-2")}>
    {extraText && (
      <span
        title={extraText}
        className="block text-sm leading-[14px] font-semibold text-gray-800 text-ellipsis overflow-hidden whitespace-nowrap max-w-[190px]"
      >
        {extraText}
      </span>
    )}

    <Price className="text-[28px] leading-7" price={price} />

    {unitOfMeasure && (
      <UnitOfMeasure className="text-sm-3/4">{unitOfMeasure}</UnitOfMeasure>
    )}
  </div>
);

export default StandardPrice;
